module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en-us":{"addTimeFrame":"Add timeframe","errors":{"endBeforeStart":"Your end time cannot be before your start time","blank":"Timeframes cannot be blank","overlap":"Your timeframes are overlapping","short":"Your timeframes must be at least {duration} minutes"}}}')
  delete Component.options._Ctor
}
